import { IconButton, InputAdornment } from "@mui/material";
import FieldBridge from "./FieldBridge";
import FieldErrorIcon from "./FieldErrorIcon";
import React, { useMemo, useRef, useState } from "react";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { StyledTextField } from "customStyled";
import { autocompleteToken, withTrimHandler } from "utils";
import FormControlUI from "./FormControlUI";
import { useTranslation } from "react-i18next";

const FormInput = (props) => {
  const { t } = useTranslation("form");
  const {
    id,
    autoComplete,
    type,
    placeholder,
    multiline = false,
    showHelperWithError = true,
    isTouchedChecked = true,
    showHoverError = false,
    rows = 4,
    errorMsg = [],
    checkType = "text",
    ariaScrollBy = "form",
    startAdornment = null,
    attr = {},
    label,
    required,
    helperText,
    sx = {},
  } = props;
  const inputRef = useRef(null);
  const [staticType, setStaticType] = useState(type);

  const togglePassword = () => {
    if (!inputRef.current) return;

    // Save current cursor position
    const cursorPos = inputRef.current.selectionStart;

    // Toggle type
    setStaticType((prev) => (prev === "text" ? "password" : "text"));

    // Focus and restore cursor after type change
    setTimeout(() => {
      const input = inputRef.current;
      if (input) {
        input.focus();
        input.setSelectionRange(cursorPos, cursorPos);
      }
    }, 0);
  };

  const startAdornmentUI = useMemo(() => {
    if (startAdornment) {
      return <InputAdornment position="start">{startAdornment}</InputAdornment>;
    }
    return null;
  }, [startAdornment]);

  return (
    <React.Fragment>
      <FieldBridge
        name={id}
        render={({ handler, hasError, touched, invalid, errors, ...rest }) => {
          const isError = (isTouchedChecked ? touched : true) && invalid;

          return (
            <FormControlUI
              showHoverError={showHoverError}
              showHelperWithError={showHelperWithError}
              label={label}
              required={required}
              id={id}
              isError={isError}
              sx={sx}
              helperText={helperText}
              errorMsg={errorMsg}
              hasError={hasError}
              errors={errors}
            >
              <StyledTextField
                inputRef={inputRef}
                inputProps={{ ...attr }}
                type={staticType}
                // id={id}
                name={id}
                {...withTrimHandler(handler, checkType)}
                multiline={multiline}
                rows={rows}
                placeholder={t("enter", { placeholder })}
                autoComplete={autocompleteToken(autoComplete)}
                variant="outlined"
                height={44}
                startAdornment={startAdornmentUI}
                endAdornment={
                  isError || type === "password" ? (
                    <InputAdornment position="end">
                      {isError ? <FieldErrorIcon /> : null}
                      {type === "password" ? (
                        <IconButton
                          onClick={togglePassword}
                          aria-label={t("togglePasswordVisibility")}
                        >
                          {staticType === "text" ? (
                            <EyeOutlined />
                          ) : (
                            <EyeInvisibleOutlined />
                          )}
                        </IconButton>
                      ) : null}
                    </InputAdornment>
                  ) : null
                }
                aria-describedby={`${id}-error-text`}
                // the container to scroll to an invalid field (formTouched.js)
                data-scroll-by={ariaScrollBy}
              />
            </FormControlUI>
          );
        }}
      />
    </React.Fragment>
  );
};

export default FormInput;
